import React, { useEffect } from 'react';
import { RiAddCircleFill } from 'react-icons/ri';
import { usePatient } from '../contexts';

import finance from '../assets/images/finance.svg';
import insurance from '../assets/images/Insurance.svg';
import referral from '../assets/images/referral.svg';
import dashboard from '../assets/images/dshb.svg';
import facility from '../assets/images/faclty.svg';
import patient from '../assets/images/pats.svg';
import chp from '../assets/images/logo.png';
import { GiCalendar, GiFiles, GiHeartburn, GiHouse, GiMoneyStack, GiNewBorn, GiPayMoney, GiPerson } from 'react-icons/gi';
import { MdFeedback, MdQueue, MdReport, MdSettings, MdUpdate, MdPayments } from 'react-icons/md';
import { FaWalking } from 'react-icons/fa';

const useNavigationItems = () => {

    const moduleList = JSON.parse(sessionStorage.getItem('moduleList') || '[]');
    const iconMap = {
        'Human Resources': <GiPerson style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        Grievance: <GiHeartburn style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        'Asset Management': <GiHouse style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        // "Admin & Store": <FaStore style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        Expense: <GiPayMoney style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        'Memo Manager': <GiFiles style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
        Payroll: <GiCalendar style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
    };


    const role = sessionStorage.getItem("role");
    const roles = JSON.parse(
        sessionStorage.getItem("roles") || "[]");

    const excludedCategories = ['Laboratory', 'Pharmacy', 'Nurse', 'Doctor'];

    // if (role?.toLowerCase() !== "Local Admin"?.toLowerCase()) {
    //     excludedCategories.push('Clinic Administration');
    // }

    if (roles?.length > 0 && !roles?.map(r => r?.name).some(r => r?.toLowerCase() === "Local Admin".toLowerCase() || r?.toLowerCase() === "Super Admin".toLowerCase())) {
        excludedCategories.push('Clinic Administration');
    }



    const menuItems = moduleList
        ?.filter((category) => !excludedCategories.includes(category?.category))

        ?.map((category) => {
            const categoryKey = category?.category?.replace(/\s+/g, '');
            return {
                key: category?.category,
                title: category?.category,
                icon: iconMap[categoryKey] || <RiAddCircleFill style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
                children: category?.module?.map((subItem) => ({
                    title: subItem?.name,
                    href: subItem?.address,
                    icon: iconMap[categoryKey] || <RiAddCircleFill style={{ width: '24px', height: '24px', color: '#3C7E2D' }} />,
                })),
            };
        });




    let labTechItems = [
        {
            title: 'Procedures',
            href: '/procedures',
            icon: <img src={insurance} className="icon" alt="Insurance Icon" />
        }
    ]

    let adminItems = [
        {
            title: 'Cost Setup',
            href: '/cost-setup',
            icon: <GiMoneyStack color='green' size={30} />
        }
    ]

    let nurseitems = [
        {
            title: 'Walk in Patient',
            href: '/walk-in',
            icon: <img src={patient} className="icon" alt="Patient Icon" />
        },
        {
            title: 'Referrals',
            href: '/referrals',
            icon: <img src={referral} className="icon" alt="Referrals Icon" />
        }
    ]

    let shownItems = []


    // if (role?.toLowerCase() === "Lab Technician".toLowerCase()) {
    //     shownItems.push(...labTechItems)

    // }
    // else if (role?.toLowerCase() === "Local Admin".toLowerCase()) {
    //     shownItems.push(...adminItems)
    // }
    // else if (role?.toLowerCase() === "Nurse".toLowerCase()) {
    //     shownItems.push(...nurseitems)
    // }
    // else if( role?.toLowerCase() === "Super Admin".toLowerCase()){
    //     shownItems.push(...adminItems,...nurseitems,...labTechItems)
    // }

    const commonItems = [
        {
            title: 'Dashboard',
            href: '/dashboard',
            icon: <img src={dashboard} className="icon" alt="Dashboard Icon" />
        },
        {
            title: 'New Walk-in Patients',
            href: '/walk-in',
            icon: <FaWalking size={20} color='green' className="icon" alt="Patient Icon" />
        },
        {
            title: 'Patients',
            href: '/patients',
            icon: <img src={patient} className="icon" alt="Patient Icon" />
        },
        {
            title: 'Approve Lab Requests',
            href: '/approve-requests',
            icon: <MdQueue size={20} color='green' className="icon" alt="Patient Icon" />
        },
        {
            title: 'Patient Queue',
            href: '/patients-queue',
            icon: <MdQueue size={20} color='green' className="icon" alt="Patient Icon" />
        },
        
        {
            title: 'Update Patient Record',
            href: '/onboard',
            icon: <MdUpdate size={20} color='green' className="icon" alt="Patient Icon" />
        },
        {
            title: 'Connect Health Pro Members',
            href: '/CHP-members',
            icon: <img src={chp} style={{ width: "20px" }} className="icon" alt="Patient Icon" />
        },
        {
            title: 'Referrals',
            href: '/referrals',
            icon: <img src={referral} className="icon" alt="Referrals Icon" />
        },
        {
            title: 'Procedures',
            href: '/procedures',
            icon: <img src={insurance} className="icon" alt="Insurance Icon" />
        },
         {
            title: 'Review Procedures',
            href: '/review-procedures',
            icon: <img src={insurance} className="icon" alt="Insurance Icon" />
        },
        {
            title: 'Cost Setup',
            href: '/cost-setup',
            icon: <GiMoneyStack color='green' size={30} />
        },
        {
            title: 'Lab Reports',
            href: '/reports',
            icon: <MdReport color='green' size={30} />
        },
        {
            title: 'Payment Records',
            href: '/payment-records',
            icon: <MdPayments color='green' size={30} />
        },
        {
            title: 'Settings',
            href: '/settings',
            icon: <MdSettings color='green' size={30} />
        }

    ];

    return [...commonItems, ...shownItems, ...menuItems, {
        title: 'Submit Feedback',
        href: '/submit-feedback',
        icon: <MdFeedback color='green' size={30} />
    },];
};

export default useNavigationItems;
